// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  appVersion: 'v1.0.0',
  USERDATA_KEY: 'auth51af0093',
  isMockEnabled: false,
  apiUrl: 'https://hotelpanel.moghim24.services',
  authApiUrl: 'https://identity.moghim24.services/api',
  interceptorsPaths: new Map<string, RegExp>([
    ['state', /state/],
    ['auth', /auth/],
    ['cache', /cache/],
    ['fake', /fake/],
    ['error', /error/],
    ['profiler', /profiler|users/],
    ['notify', /notify/],
    ['header', /header/],
    ['convert', /convert/],
    ['loader', /loader/],
    ['https', /https/],
  ])
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
